import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Sparkles } from "lucide-react";

/**
 * Web Share Target handler (PWA — audit #4).
 *
 * When Impo is installed and the OS shares content to it (Android/iOS/desktop),
 * the manifest routes the intent to /app/share?title=…&text=…&url=…
 * We compose a single string and redirect to /app/chat?share=… so the Chat
 * screen can auto-fill the input.
 */
export default function ShareTarget() {
  const nav = useNavigate();
  const [sp] = useSearchParams();

  useEffect(() => {
    const title = sp.get("title") || "";
    const text  = sp.get("text")  || "";
    const url   = sp.get("url")   || "";
    const composed = [title, text, url].filter(Boolean).join("\n\n").trim();

    if (composed) {
      // Pass to Chat via query — Chat.jsx handles ?share=... below.
      nav(`/app/chat?share=${encodeURIComponent(composed)}`, { replace: true });
    } else {
      // Nothing to share → just open Chat.
      nav("/app/chat", { replace: true });
    }
  }, [sp, nav]);

  return (
    <div className="min-h-[60vh] grid place-items-center px-6" data-testid="share-target">
      <div className="text-center">
        <div className="h-12 w-12 rounded-2xl bg-primary/10 text-primary grid place-items-center mx-auto animate-pulse">
          <Sparkles className="h-6 w-6" />
        </div>
        <div className="font-display font-semibold mt-3">Opening Impo…</div>
        <div className="text-xs text-muted-foreground">Bringing your shared content into chat</div>
      </div>
    </div>
  );
}
